export const trimSignatureImageDataUrl = async (dataUrl) => {
  if (!dataUrl || typeof window === "undefined") {
    return dataUrl || "";
  }

  return new Promise((resolve) => {
    const image = new Image();

    image.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = image.naturalWidth || image.width;
        canvas.height = image.naturalHeight || image.height;

        const context = canvas.getContext("2d", { willReadFrequently: true });
        if (!context || !canvas.width || !canvas.height) {
          resolve(dataUrl);
          return;
        }

        context.drawImage(image, 0, 0);
        const { data, width, height } = context.getImageData(0, 0, canvas.width, canvas.height);

        let left = width;
        let top = height;
        let right = -1;
        let bottom = -1;
        let foundDarkPixel = false;

        for (let y = 0; y < height; y += 1) {
          for (let x = 0; x < width; x += 1) {
            const offset = (y * width + x) * 4;
            const red = data[offset];
            const green = data[offset + 1];
            const blue = data[offset + 2];
            const alpha = data[offset + 3];

            if (alpha > 20 && red + green + blue < 690) {
              foundDarkPixel = true;
              if (x < left) left = x;
              if (y < top) top = y;
              if (x > right) right = x;
              if (y > bottom) bottom = y;
            }
          }
        }

        if (!foundDarkPixel) {
          for (let y = 0; y < height; y += 1) {
            for (let x = 0; x < width; x += 1) {
              const offset = (y * width + x) * 4;
              const alpha = data[offset + 3];
              if (alpha > 0) {
                if (x < left) left = x;
                if (y < top) top = y;
                if (x > right) right = x;
                if (y > bottom) bottom = y;
              }
            }
          }
        }

        if (right < left || bottom < top) {
          resolve(dataUrl);
          return;
        }

        const contentWidth = right - left + 1;
        const contentHeight = bottom - top + 1;
        const paddingX = Math.max(4, Math.round(contentWidth * 0.03));
        const paddingY = Math.max(4, Math.round(contentHeight * 0.12));
        const cropLeft = Math.max(0, left - paddingX);
        const cropTop = Math.max(0, top - paddingY);
        const cropRight = Math.min(width, right + paddingX + 1);
        const cropBottom = Math.min(height, bottom + paddingY + 1);
        const cropWidth = cropRight - cropLeft;
        const cropHeight = cropBottom - cropTop;

        if (cropWidth <= 0 || cropHeight <= 0) {
          resolve(dataUrl);
          return;
        }

        const trimmedCanvas = document.createElement("canvas");
        trimmedCanvas.width = cropWidth;
        trimmedCanvas.height = cropHeight;
        const trimmedContext = trimmedCanvas.getContext("2d");
        if (!trimmedContext) {
          resolve(dataUrl);
          return;
        }

        trimmedContext.drawImage(
          canvas,
          cropLeft,
          cropTop,
          cropWidth,
          cropHeight,
          0,
          0,
          cropWidth,
          cropHeight
        );

        resolve(trimmedCanvas.toDataURL("image/png"));
      } catch {
        resolve(dataUrl);
      }
    };

    image.onerror = () => resolve(dataUrl);
    image.src = dataUrl;
  });
};
